import React from 'react';
import type { GcsPerformanceRow } from '@/types/api/neurologicalAssessment';

export interface AssessmentStats {
  score?: string | number;
  scoreSub?: string;
  correctCount?: string | number;
  total?: string | number;
  duration?: string | number;
}

export interface GcsEvaluationResultViewData {
  stats?: AssessmentStats;
  performance?: GcsPerformanceRow[];
}

export interface PupilReactionPerformanceRow {
  no?: number;
  name?: string;
  gender?: string;
  age?: string | number;
  position?: string;
  pupil_size?: string | number;
  pupil_reaction?: string;
  pupil_shape?: string;
  correct_pupil_size?: string | number;
  correct_pupil_reaction?: string;
  correct_pupil_shape?: string;
  result?: string;
  completed_missed?: string;
  comment?: string;
  [key: string]: unknown;
}

export interface PupilReactionEvaluationResultViewData {
  stats?: AssessmentStats;
  performance?: PupilReactionPerformanceRow[];
}

/** GCS·동공·근력 등 신경평가 결과 표 공통 래퍼 */
export function AssessmentTableShell({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <div className="space-y-10 !mb-10">
      <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
      <div className="rounded-xl border border-gray-200 overflow-hidden bg-white overflow-x-auto">{children}</div>
    </div>
  );
}
